// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.d2-contextmenu {\r\n  position: absolute;\r\n  padding: 5px 0;\r\n  z-index: 2018;\r\n  background: #FFF;\r\n  border: 1px solid #cfd7e5;\r\n  border-radius: 4px;\r\n  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);\r\n          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);\n}\r\n", ""]);
// Exports
module.exports = exports;
